module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zan-step",
    class: ("zan-step--" + _vm.status)
  }, [_c('div', {
    staticClass: "zan-step__circle-container"
  }, [(_vm.status !== 'process') ? _c('i', {
    staticClass: "zan-step__circle"
  }) : _c('i', {
    staticClass: "zan-icon zan-icon-checked"
  })]), _vm._v(" "), _c('p', {
    staticClass: "zan-step__title"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "zan-step__line"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13ae9b68!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/steps/src/step.vue
// module id = 163
// module chunks = 0 2